import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { showSpinner, showModal } from '../../../actions'
import MySybmittedLotDetails from './LotDetails'

const mapStateToProps = (state) => {
  return {
    userId: state.user.data._id
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ showSpinner, showModal }, dispatch)
}

const LotDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MySybmittedLotDetails)

export default LotDetailsContainer
